import { render, staticRenderFns } from "./referenceInformation.vue?vue&type=template&id=18a349be&scoped=true&"
import script from "./referenceInformation.vue?vue&type=script&lang=js&"
export * from "./referenceInformation.vue?vue&type=script&lang=js&"
import style0 from "./referenceInformation.vue?vue&type=style&index=0&id=18a349be&lang=scss&scoped=true&"
import style1 from "./referenceInformation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a349be",
  null
  
)

export default component.exports